<script setup lang="ts">
import {defineProps, computed, ref} from 'vue';
import Vue from 'vue';
import {QrCode} from "lucide-vue"
import VModal from 'vue-js-modal';
import QrcodeStyling from "@/components/other/QrcodeStyling.vue";
Vue.use(VModal);

const props = defineProps({
  url: {type: String, required: true},
  txid: {type: String, required: true},
})

const txUrl = computed(() => {
  return props.url;
})

const txId = computed(() => {
  return props.txid;
})

const modalRef = ref(null)

const modalName = computed(() => {
  return 'qrcode-modal' + txId.value;
})

const showQrCode = () => {
  //console.log(modalRef.value);
  modalRef.value.$modal.show(modalName.value);
}

const qrcodeConfig = {
    width: 250,
    height: 250,
    type: "svg",
    margin: 0,
    //data: "https://www.facebook.com/",
    // image: 'data:image/svg+xml;base64,' + CapLogoImage.logoWorking, //"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
    dotsOptions: {
      color: "#627f23", //93bb36
      type: "square"
    },
    backgroundOptions: {
      color: "#ffffff",
    },
    cornersSquareOptions: {
      "type": "extra-rounded",
      //"color": "#000000"
    },
    imageOptions: {
      hideBackgroundDots: true,
      crossOrigin: "anonymous",
      imageSize: 0.5,
      margin: 0
    },
    qrOptions: {typeNumber: "0", mode: "Byte", errorCorrectionLevel: "H"}
}
</script>

<template>
  <div class="link-wrapper">
    <a v-bind="$attrs"
       :href="txUrl"
       target="_blank" :title="txId">{{ txId }}</a>
    <a @click.prevent.stop="showQrCode" href="#" class="qrcode-icon-wrapper">
      <QrCode :size="30" color="#80bd1c" />
    </a>
    <modal ref="modalRef" :name="modalName"
           class="qrcode-modal"
           :adaptive="true" width="350" height="auto" :clickToClose="true">
      <div class="qrcode-modal__inner">
        <div class="qrcode__wrapper">
          <QrcodeStyling :logo-working="false"
                         :size="250"
                         :qrcode-styling-config="qrcodeConfig"
                         :source-data="txUrl ? txUrl : txId"/>
        </div>
        <h3>tx: <strong>{{txId}}</strong></h3>
      </div>
    </modal>
  </div>
</template>

<style scoped lang="less">
.qrcode-modal {
  h3 {
    font-weight: 400;
    line-height: 1.3em;
    white-space: wrap;
    word-break: break-all;
    strong {
      font-weight: 600;
      user-select: all;
    }
  }
  .qrcode-modal__inner {
    padding: 35px 35px;
    .qrcode__wrapper {
      width: fit-content;
      height: fit-content;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;

      border: 1px solid #80bd1c;
      border-radius: 8px;
      padding: 5px;
    }
  }
  ::v-deep {
    .vm--modal {
      border-radius: 6px;
      display: block;
      line-height: 0;
    }
  }
}
.qrcode-icon-wrapper{
  border: 1px solid #80bd1c;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}
.link-wrapper {
  display: flex;
  align-items: center;
  gap: 1.5ex;
}
</style>
